import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../components/header/header.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { ButtonComponent } from '../../components/button/button.component';
import { CountryService } from '../../services/country.service';
import { GlobalService } from '../../services/global.service';
import { ValidationService } from '../../services/validation.service';
import { DropdownService } from '../../services/dropdown.service';

@Component({
  selector: 'app-country-form-page',
  imports: [CommonModule, ReactiveFormsModule, HeaderComponent, TextInputComponent, ButtonComponent],
  templateUrl: './country-form-page.component.html',
  styleUrl: './country-form-page.component.css'
})
export class CountryFormPageComponent {
  form: FormGroup;
  selected_item: any = {};
  isSubmitting = false;

  constructor(
    public gs: GlobalService,
    public cs: CountryService,
    public ds: DropdownService,
    public vs: ValidationService,
    public fb: FormBuilder,
    public route: Router,
    public ar: ActivatedRoute,
  ) {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.location_name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      is_active: [true]
    });
  }

  async ngOnInit() {
    this.ar.queryParams.subscribe(async params => {
      if (params['id']) {
        const res = await this.cs.get(params['id']);
        this.selected_item = res?.data || {};
        this.form.patchValue(this.selected_item);
      }
    });
  }

  discard() {
    this.route.navigate(['/country/list']);
  }

  async submit() {
    if (this.isSubmitting) return;
    if (this.form.invalid) {
      this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
      this.form.markAllAsTouched();
      return;
    }
    this.isSubmitting = true;
    try {
      const value = { ...this.form.value, is_active: true };
      if (this.selected_item?.id) {
        await this.cs.update(this.selected_item.id, value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        const res = await this.cs.add(value);
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.ds.invalidate_dropdown_cache('country');
      this.route.navigate(['/country/list']);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }
}
